module.exports = __webpack_public_path__ + "static/img/X智慧云平台.95dbffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/智能碰撞预警系统/X智慧云平台.png
// module id = rLaO
// module chunks = 0